export default class Newsletter {
	constructor( element ) {
		if ( null === element ) {
			return;
		}

        this.element = element;
        this.input = element.querySelector( '[data-newsletter="input"]' );
        this.button = element.querySelector( '[data-newsletter="button"]' );
		this.agreement = element.querySelector( '[data-newsletter="agreement"]' );

		this.init();
	}

	init() {
		this.element.addEventListener( 'submit', ( e ) => {
            e.preventDefault();

			if ( this.agreement.checked === false ) {
				return false;
			}

			let data = new FormData( this.element );
			data.append( 'action', 'newsletter_subscribe_user' );
			data.append( 'security', themeVars.newsletter.newsletter_nonce );

			let request = new XMLHttpRequest();
			request.open( 'POST', themeVars.ajax_url, true );
			request.send( data );

			this.input.disabled = true;
            this.button.disabled = true;

			request.onreadystatechange = () => {
				if ( request.readyState === 4 && request.status === 200 ) {
					let response = JSON.parse( request.responseText );

					if ( response.success === true ) {
                        this.input.value = response.data.success;
                        this.element.classList.add( 'success' );
                    } else {
                        this.input.value = response.data.error;
                        this.element.classList.add( 'error' );
                    }

                    setTimeout( () => {
                        this.input.value = '';
                        this.input.removeAttribute( 'disabled' );
                        this.button.removeAttribute( 'disabled' );
                        this.element.classList.remove( [ 'success', 'error' ] );
                        this.input.focus();
                    }, 4000 );
				}
			}
		} );

		this.agreement.addEventListener( 'change', ( e ) => {
			if ( this.agreement.checked ) {
				this.button.disabled = false;
			} else {
				this.button.disabled = true;
			}
		} );
	}
}
